export const font = {
  s: '0.75rem',
  m: '0.875rem',
  normal: '1rem',
  l: '1.125rem',
  xl: '1.25rem',
  xxl: '1.5rem'
};
